module.exports = "/images/edit.svg?5898f99d2490f17660ed78623b300a25";